import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { assertAdminOrManager } from './Utils/Permission';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export class RefundSlotUseCase {
  constructor(private repo: SlotRepository) {}
  execute(id: number, current: User) {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(current)) {
      throw new Error(getRestrictionMessage('환불', current));
    }

    assertAdminOrManager(current);
    return this.repo.refundSlot(id);
  }
}